(function(angular) {
    'use strict';

    angular.module('aprima-facility-api').factory('FacilitySettingsRepository', [
        'AprimaAnalytics',
        'AprimaRestangular',
        FacilitySettingsRepository
    ]);

    function FacilitySettingsRepository(
        AprimaAnalytics,
        AprimaRestangular
    ) {
        return {
            getSettings: getSettings,
        };

        function getSettings() {
            var timing = AprimaAnalytics.startTiming('FacilitySettingsRepository', 'api', 'getSettings');
            var restangular = AprimaRestangular.get('facility');
            return restangular.one('settings')
                              .get()
                              .finally(timing.stop);
        }
    }
})(window.angular);
